export default {
  categories: '类别',
  segments: '段',
  businesses: '企业',
  active: '积极',
  inactive: '无效',
  noBusinessesCreated: '未创建任何企业',
  newBusiness: '新业务',
  editBusiness: '编辑业务',
  businessUrl: '业务 URL',
  segment: '段',
  insertExtraDataName: '插入额外的数据名称',
  insertExtraDataValues: '插入额外的数据值',
  delete: '删除',
  addExtraData: '添加额外数据',
  businessSuccessfullyCreated: '已成功创建业务',
  businessSuccessfullyEdited: '已成功编辑业务',
  addNewBusiness: '添加新业务',
  uploadPhoto: '上传照片',
  doYouWantToDeleteThisContact: '是否要删除此联系人？',
  deleteContact: '删除联系人',
  contactSuccessfullyDeleted: '已成功删除联系人',
  doYouWantToDeleteThisBusiness: '是否要删除此业务？',
  deleteBusiness: '删除业务',
  businessSuccessfullyDeleted: '已成功删除业务',
  errorLoadingTheBusiness: '加载业务时出错',
  addContact: '添加联系人',
  nameOfTheBusiness: '企业名称',
  noCategories: '无类别',
  noLocation: '无位置',
  noAddress: '无地址',
  noSegment: '无段',
  contactSuccessfullyAdded: '已成功添加联系人',
  contacts: '接触',
  noRoles: '无角色',
  loadingBusinessContacts: '正在加载业务联系人',
  noBusinessContacts: '此企业没有联系人'
}
